import { Avatar, Badge, makeStyles } from "@material-ui/core";
import { useEffect, useState } from "react";

import useUpdateMemberImage from "../hooks/useUpdateMemberImage";
import EditIcon from "../assets/icons/edit.png";
import useSFAlert from "../hooks/useSFAlert";

const useStyles = makeStyles(() => {
  return {
    avatar: {
      width: 142,
      height: 142,
      marginTop: 10,
    },
    avatarBorder: {
      marginTop: 20,
      justifyContent: "center",
      display: "flex",
      width: "114px",
      height: "114px",
      alignItem: "center",
    },
    editIcon: {
      height: 27,
      width: 27,
    },
  };
});

const AvatarforMemberPanel = ({
  alt,
  src = null,
  memberId,
  version,
  isPotential = false,
}) => {
  const classes = useStyles();
  const [image, setImage] = useState(src);
  const { updateMemberImage } = useUpdateMemberImage();
  const [alert] = useSFAlert();
  useEffect(() => {
    setImage(src);
  }, [src]);

  if (!alt || !memberId || (!version && version !== 0)) {
    alert(
      `AvatarforMemberPanel : missing parameters alt:${alt}  memberId:${memberId} version:${version}`
    );
    return <div>Error</div>;
  }
  const onChangeSelectImageHandler = async (file) => {
    //Simple Validate image
    if (file.size > 10000000) {
      return;
    }

    const [result, error] = await updateMemberImage({
      memberId,
      version,
      image: {
        rawFile: file,
        src: URL.createObjectURL(file),
        title: "profile",
      },
      isPotential,
    });

    if (error) alert(error.message);
    if (result) window.location.reload();
  };
  return (
    <>
      <input
        accept="image/*"
        id="contained-button-file"
        type="file"
        style={{ display: "none" }}
        onChange={(e) => onChangeSelectImageHandler(e.target.files[0])}
      />
      <label htmlFor="contained-button-file">
        <Badge
          overlap="circle"
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          badgeContent={
            <Avatar alt="edit" src={EditIcon} className={classes.editIcon} />
          }
        >
          <Avatar alt={alt} src={image} className={classes.avatar}></Avatar>
        </Badge>
      </label>
    </>
  );
};

export default AvatarforMemberPanel;
